import { render, staticRenderFns } from "./OrgFieldtype.vue?vue&type=template&id=2a9a5bdc&"
import script from "./OrgFieldtype.vue?vue&type=script&lang=js&"
export * from "./OrgFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports